(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["CustomTabs"] && !Shopify.designMode) return;
  try {
    
  tabs= document.querySelectorAll('.custom-tab');
  tabContents= document.querySelectorAll('.custom__tab-content');

  tabs.forEach(function(tab){
      tab.addEventListener('click',function(){

          contentId = this.dataset.contentId;
          content = document.getElementById(contentId);

          tabContents.forEach(function(content){
              content.classList.remove('active');
          });

          tabs.forEach(function(tab){
              tab.classList.remove('active');
          });

          this.classList.add('active');
          content.classList.add('active');
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  // ĐÃ FIX: Sử dụng try...catch để bỏ qua lỗi nếu 'sticky-header' đã được định nghĩa ở global.js
  try {
    if (!customElements.get('sticky-header')) {
      customElements.define('sticky-header', StickyHeader);
    }
  } catch (e) {
    console.warn("StickyHeader registration skipped: ", e);
  }
  // ─────────────────────────────────────────────
  // MOBILE CUSTOM MENU – Dropdown logic (ĐÃ FIX)
  // ─────────────────────────────────────────────
    // ─────────────────────────────────────────────
  // MOBILE CUSTOM MENU – Portal & Event Delegation (ĐÃ FIX TRIỆT ĐỂ)
  // ─────────────────────────────────────────────
    // ─────────────────────────────────────────────
  // MOBILE CUSTOM MENU – Dynamic Portal (ĐÃ SỬA LỖI GIÃN KHOẢNG TRẮNG)
  // ─────────────────────────────────────────────
  function initCustomMobileMenu() {
    var headerWrapper = document.querySelector('.header-wrapper');
    var nav = document.querySelector('.custom-mobile-menu');
    var overlay = document.getElementById('custom-mobile-overlay');
    
    if (!headerWrapper || !nav) return;

    function closeAll() {
      var allItems = document.querySelectorAll('[data-mobile-nav-item]');
      allItems.forEach(function (item) {
        item.classList.remove('is-open');
        var btn = item.querySelector('[data-mobile-nav-trigger]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });

      // Ẩn tất cả dropdowns bất kể đang nằm ở đâu
      var allDropdowns = document.querySelectorAll('[data-mobile-dropdown]');
      allDropdowns.forEach(function (dd) {
        dd.style.display = 'none';
      });

      if (overlay) overlay.classList.remove('is-visible');
    }

    function openDropdown(item, dropdown) {
      closeAll();
      item.classList.add('is-open');
      var trigger = item.querySelector('[data-mobile-nav-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      
      // DYNAMIC PORTAL: Di chuyển dropdown ra .header-wrapper ngay khi click để tránh lỗi giãn Grid
      if (dropdown.parentElement !== headerWrapper) {
        headerWrapper.appendChild(dropdown);
      }
      
      // Hiển thị dropdown
      dropdown.style.display = 'block';
      if (overlay) overlay.classList.add('is-visible');

      // Đo đạc khoảng cách và định vị sát khít bên dưới menu ngang
      var wrapperRect = headerWrapper.getBoundingClientRect();
      var navRect = nav.getBoundingClientRect();
      var topVal = navRect.bottom - wrapperRect.top;
      dropdown.style.top = topVal + 'px';
    }

    // Lắng nghe sự kiện click trên toàn document (Event Delegation)
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-mobile-nav-trigger]');
      
      if (trigger) {
        var item = trigger.closest('[data-mobile-nav-item]');
        if (item) {
          // Lưu liên kết trực tiếp vào trigger để truy xuất chính xác kể cả khi đã di chuyển phần tử
          if (!trigger.mobileDropdown) {
            trigger.mobileDropdown = item.querySelector('[data-mobile-dropdown]');
          }
          var dropdown = trigger.mobileDropdown;

          if (dropdown) {
            e.preventDefault();
            e.stopPropagation();
            
            var isOpen = item.classList.contains('is-open');
            if (isOpen) {
              closeAll();
            } else {
              openDropdown(item, dropdown);
            }
            return;
          }
        }
      }

      // Click ra ngoài -> Đóng menu
      var isInsideMenu = e.target.closest('.custom-mobile-menu');
      var isInsideDropdown = e.target.closest('[data-mobile-dropdown]');
      var isOverlay = e.target.closest('.custom-mobile-overlay');
      
      if ((!isInsideMenu && !isInsideDropdown) || isOverlay) {
        closeAll();
      }
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 990) {
        closeAll();
      } else {
        var openItem = document.querySelector('[data-mobile-nav-item].is-open');
        if (openItem) {
          var openTrigger = openItem.querySelector('[data-mobile-nav-trigger]');
          if (openTrigger && openTrigger.mobileDropdown) {
            openDropdown(openItem, openTrigger.mobileDropdown);
          }
        }
      }
    });
  }

  // Khởi chạy an toàn
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomMobileMenu);
  } else {
    initCustomMobileMenu();
  }

  } catch(e) { console.error(e); }
})();
})();
